<div class="admin-expense-quota content-wrapper container-fluid">
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">
        {{ t('توكنات تحليل المصاريف (يدوي)', 'Expense analysis tokens (manual adjust)', 'טוקני ניתוח הוצאות (התאמה ידנית)') }}
      </h5>
      <p class="small text-muted mb-0 mt-2">
        {{ t(
          'تم إلغاء كوتا المصاريف الشهرية. استخدم هذا النموذج لزيادة رصيد التوكنات على اشتراك الفواتير النشط للتاجر.',
          'Monthly expense quota was removed. Use this form to add analysis tokens to the merchant\'s active invoice subscription.',
          'מכסת ההוצאות החודשית הוסרה. השתמש בטופס זה להוספת טוקני ניתוח למנוי החשבוניות הפעיל של הסוחר.'
        ) }}
      </p>
    </div>
    <div class="card-body">
      <form [formGroup]="adjustForm" class="row g-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label">{{ t('التاجر', 'Merchant', 'סוחר') }} *</label>
          <select class="form-select" formControlName="merchant_id" (change)="onMerchantChange()">
            <option [ngValue]="null">{{ t('اختر التاجر', 'Select merchant', 'בחר סוחר') }}</option>
            <option *ngFor="let m of merchantOptions" [ngValue]="m.id">{{ m.name }} (#{{ m.id }})</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">{{ t('توكنات إضافية', 'Extra tokens', 'טוקנים נוספים') }} *</label>
          <input type="number" class="form-control" min="1" formControlName="extra_tokens" />
        </div>
        <div class="col-md-4">
          <button type="button" class="btn btn-primary" (click)="submitAdjust()" [disabled]="adjustForm.invalid">
            {{ t('تطبيق', 'Apply adjustment', 'החל שינוי') }}
          </button>
        </div>
      </form>

      <div class="mt-4" *ngIf="loadingPreview">
        <span class="spinner-border spinner-border-sm me-2"></span>
        {{ t('جاري التحميل…', 'Loading…', 'טוען…') }}
      </div>

      <div class="mt-4 p-3 bg-light rounded" *ngIf="!loadingPreview && subscriptionPreview">
        <h6 class="mb-2">{{ t('معاينة الاشتراك', 'Subscription snapshot', 'תצוגת מנוי') }}</h6>
        <pre class="small mb-0" style="white-space: pre-wrap; max-height: 320px; overflow: auto;">{{ subscriptionPreview | json }}</pre>
      </div>
    </div>
  </div>
</div>
